import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declaration, DeclarationCustomsType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  declaration: Partial<Declaration>;
  reason: string;
  invalidationMotivation?: string;
}

export const useInvalidateOneHv = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declaration, reason, invalidationMotivation }: HookProps) => {
      if (declaration.customsState) {
        const sentTo = [
          DeclarationCustomsType.AES,
          DeclarationCustomsType.NL_AES,
          DeclarationCustomsType.IDMS,
          DeclarationCustomsType.DMS,
          DeclarationCustomsType.FR_DELTA_IE_HV,
        ].includes(declaration.customsState?.sentTo);

        if (sentTo) {
          const result = await apiClient.idms.invalidate.mutation({ body: { LRN: declaration.messageInfo.LRN, reason, invalidationMotivation } });
          if (result.status !== 200) {
            throw result.body;
          }
        } else {
          const result = await apiClient.declarationsCustoms.invalidateOneReleasedToPlda.mutation({
            body: { LRN: declaration.messageInfo.LRN, reason },
          });
          if (result.status !== 200) throw result.body;
        }
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declaration._id] });
      toast.success('Invalidation request was sent!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the invalidation request!`);
    },
  });
};
